/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ScoreReferenceAliases {
  FIELD_REFERENCE = 'field-reference',
  FORM_SCORE_REFERENCE = 'form-score-reference',
  LAYOUT_SCORE_REFERENCE = 'layout-score-reference',
  PANEL_SCORE_REFERENCE = 'panel-score-reference',
  TEXT_REFERENCE = 'text-reference',
}
export { ScoreReferenceAliases };
